"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyViewConfigRow = createEmptyViewConfigRow;
const app_base_config_1 = require("./app-base-config");
/**
 * sl-bpu6.4: Default row shape for a newly-provisioned AppBase.
 * Caller supplies `name`, `contentDbRef`, and optionally `isDefault`.
 * Everything else is the spec-defined neutral default.
 */
function createEmptyViewConfigRow(input) {
    const appBaseConfig = input.dataSources
        ? (0, app_base_config_1.createDefaultAppBaseConfig)({
            title: input.name,
            dataSources: input.dataSources,
            defaultLocale: input.defaultLocale,
        })
        : (0, app_base_config_1.createAppBaseConfigFromContentDbRef)({
            name: input.name,
            contentDbRef: input.contentDbRef,
            defaultLocale: input.defaultLocale,
        });
    return {
        name: input.name,
        layoutType: 'list',
        rowDetailMode: 'none',
        inlineEdit: false,
        nav: 'none',
        search: false,
        pagination: 'none',
        hero: false,
        entryStyle: 'plain',
        tags: false,
        form: false,
        seoSlugCol: null,
        seoMetaCol: null,
        seoOgCol: null,
        seoCanonicalCol: null,
        seoRobotsIndex: true,
        seoTitleFormula: null,
        seoDescriptionFormula: null,
        seoOgImageFormula: null,
        contentDbRef: input.contentDbRef,
        appBaseConfig,
        themeRef: null,
        bindings: {},
        isDefault: input.isDefault ?? true,
    };
}
